import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Refill } from '../models/refill';
import { DateHandlerService } from '../commons/date-handler.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../auth-n-routing/auth-service.service';
import { BehaviorSubject } from 'rxjs';
import {BusyServices} from '../commons/busy.service';

@Injectable()
export class RefillsHandlerService {

	private addRefillURI = 'refuels/add';
	private getByUserIDURI = 'refuels/getByUserID';
	private getByAdminIDURI = 'refuels/getByAdminID';
	private getByAdminIDCountURI = 'refuels/getByAdminIDCount';
	private getByUserIDCountURI = 'refuels/getByUserIDCount';
	private getRefillsByTravelIDUri = 'refuels/getByTravelID';
	private approveURI = 'refuels/approve';
	private declineURI = 'refuels/decline';
	private restoreURI = 'refuels/restore';
	private updateKilometers = 'refuels/updateKilometers';
	private getRefillsByParkIdUri = 'refuels/getByParkID?park_id=';
	private updateRefillUri = 'refuels/update';

	public filterNameUpdateRequired: BehaviorSubject<string>;
	refills_list: Refill[] = [];
	refills_list_props = {
		count: 0,
		current_page: 1,
		item_per_page: 10,
		filtro_value: '',
		filter_column: '',
		filter_value: '',
		status_attivo: 0,
		data_inizio: null,
		data_fine: null
	};

	constructor(private busy: BusyServices, private http: HttpClient, private sanitizer: DomSanitizer,
				private dateHandlerService: DateHandlerService,
				private authService: AuthService) {
		this.filterNameUpdateRequired = new BehaviorSubject<string>('Filtra per...');
	}

	restoreBodyRefillsFilters() {
		this.refills_list_props = {
			count: 0,
			current_page: 1,
			item_per_page: 10,
			filtro_value: '',
			filter_column: '',
			filter_value: '',
			status_attivo: 0,
			data_inizio: null,
			data_fine: null
		};
	}

	getBodyRefillsFilter(user_id: number) {
		return {
			'user_id': user_id.toString(),
			'page_number': this.refills_list_props.current_page.toString(),
			'items_per_page': this.refills_list_props.item_per_page.toString(),
			'status_attivo': this.refills_list_props.status_attivo,
			'filter_column': this.refills_list_props.filter_column,
			'filter_value': this.refills_list_props.filter_value,
			'data_inizio': this.dateHandlerService.formatDateNoTime(this.refills_list_props.data_inizio),
			'data_fine': this.dateHandlerService.formatDateNoTime(this.refills_list_props.data_fine),
		};
	}

	changeFilterName(newFilter: string) {
		this.filterNameUpdateRequired.next(newFilter);
	}

	reloadRefillsListAndCount(): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			this.getRefillsCount(this.authService.getAuthenticatedUser().id).then((counted) => {
				this.refills_list_props.count = counted;
				this.reloadRefillsList().then((res) => {
					resolve(res);
				});
			});
		});
	}

	reloadRefillsList(): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			if (this.authService.is_admin()) {
				this.getByAdminID(this.authService.getAuthenticatedUser().id).then((data) => {
					this.refills_list = data;
					resolve(true);
				});
			} else {
				this.getByUserID(this.authService.getAuthenticatedUser().id).then((data) => {
					this.refills_list = data;
					resolve(true);
				});
			}
		});
	}

	addRefill(refill: Refill): Promise<boolean> {
		console.log(refill);
		return new Promise<boolean>((resolve, rejec ) => {
			const formData: FormData = new FormData();
			formData.append('box_pic', refill.box_pic);
			formData.append('recive_pic', refill.recive_pic);
			formData.append('quantity', refill.quantity.toString());
			formData.append('amount', refill.amount.toString());

			if (refill.latitude) {
				formData.append('latitude', refill.latitude.toString());
			}

			if (refill.longitude) {
				formData.append('longitude', refill.longitude.toString());
			}

			if (refill.altitude) {
				formData.append('altitude', refill.altitude.toString());
			}

			formData.append('kilometers', refill.kilometers.toString());
			formData.append('fuel_level', refill.fuel_level.toString());
			// formData.append('status.id', refill.status.id.toString());
			formData.append('travel_id', refill.travel.id.toString());
			formData.append('made_at', this.dateHandlerService.formatDate(refill.made_at));
			const _http = this.http.post(environment.api.baseUrl + this.addRefillURI, formData,
				{
					headers: { 'Authorization': environment.api.config.headers.Authorization }
				}).subscribe((data: any) => {
				resolve(true);

			}, error1 => {
				rejec(error1);
			});
			this.busy.setBusy(_http);
		});
	}

	getByUserID(user_id: number): Promise<Refill[]> {
		return new Promise<Refill[]>((resolve, rejec) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByUserIDURI,
				this.getBodyRefillsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const refill_raw = vehicle_server_obj['refill'];
							toRet.push(new Refill(refill_raw));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	getRefillsByTravelID(travel_id: string, page_number: number): Promise<Refill[]> {
		return new Promise<Refill[]>((resolve, rejec) => {
			const _http = this.http.post(environment.api.baseUrl + this.getRefillsByTravelIDUri,
				{ 'travel_id': travel_id, 'page_number': page_number },
				environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((reff) => {
							toRet.push(new Refill(reff['refill']));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	getByAdminID(user_id: number): Promise<Refill[]> {
		return new Promise<Refill[]>((resolve, rejec) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByAdminIDURI,
				this.getBodyRefillsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const refill_raw = vehicle_server_obj['refill'];
							toRet.push(new Refill(refill_raw));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	getRefillsCount(user_id: number): Promise<number> {
		if (this.authService.is_admin()) {
			return this.getByAdminIDCount(user_id);
		} else {
			return this.getByUserIDCount(user_id);
		}
	}
	getByAdminIDCount(user_id: number): Promise<number> {
		return new Promise<number>((resolve, rejec) => {

			const _http = this.http.post(environment.api.baseUrl + this.getByAdminIDCountURI,
				this.getBodyRefillsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					resolve(data.refill);
				});
			this.busy.setBusy(_http);
		});
	}

	getByUserIDCount(user_id: number): Promise<number> {
		return new Promise<number>((resolve, rejec) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByUserIDCountURI,
				this.getBodyRefillsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					resolve(data.refill);
				});
			this.busy.setBusy(_http);
		});
	}

	approveRefill(refill: Refill): Promise<Refill> {
		return new Promise<Refill>((resolve, rejec) => {
			const _http = this.http.post(environment.api.baseUrl + this.approveURI,
				{
					'refill_id': refill.id.toString(),
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
				(data: any) => {
					resolve(new Refill(data.refill));
				});
			this.busy.setBusy(_http);
		});
	}

	declineRefill(refill: Refill): Promise<Refill> {

		return new Promise<Refill>((resolve, rejec) => {
			const _http = this.http.post(environment.api.baseUrl + this.declineURI,
				{
					'refill_id': refill.id.toString(),
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
				(data: any) => {
					resolve(new Refill(data.refill));
				});
			this.busy.setBusy(_http);
		});
	}

	restoreRefill(refill: Refill): Promise<Refill> {
		return new Promise<Refill>((resolve, rejec ) => {
			const _http = this.http.post(environment.api.baseUrl + this.restoreURI,
				{
					'refill_id': refill.id.toString(),
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
				(data: any) => {
					resolve(new Refill(data.refill));
				});
			this.busy.setBusy(_http);
		});
	}

	getImage(url: string): Promise<any> {
		return new Promise<any>((resolve, rejec) => {
			const _http = this.http.get(url, {
				responseType: 'blob',
				headers: environment.api.config.headers
			}).subscribe(
				(data: any) => {
					resolve(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(data)));
				});
			this.busy.setBusy(_http);
		});
	}

	getAllRefills(user, count): Promise<Refill[]> {
		return new Promise<Refill[]>((resolve) => {
			const test = this.getBodyRefillsFilter(user.id);
			test.items_per_page = count;
			let url = this.getByUserIDURI;
			if (user.is_admin) {
				url = this.getByAdminIDURI;
			}
			const _http = this.http.post(environment.api.baseUrl + url, test, environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const refill_raw = vehicle_server_obj['refill'];
							toRet.push(new Refill(refill_raw));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	updateRefillsKilometers(refills): Promise<Refill> {
		return new Promise<Refill>((resolve, reject) => {
			const url = this.updateKilometers;
			const _http = this.http.post(environment.api.baseUrl + url, refills, environment.api.config).subscribe((data: any) => {
				if (data.refill) {
					const refil = new Refill(data.refill);
					resolve(refil);
				} else {
					reject();
				}
			}, error => {
				console.log(error);
			});
			this.busy.setBusy(_http);
		});
	}

	getRefillsByParkId(parkId: string): Promise<Refill[]> {
		return new Promise<Refill[]>((resolve, reject) => {
			const _http = this.http.get(environment.api.baseUrl + this.getRefillsByParkIdUri + parkId, environment.api.config)
				.subscribe((data: any) => {
					if (data.refill) {
						resolve(data.refill);
					} else {
						reject();
					}
				});

			this.busy.setBusy(_http)
		});
	}

	updateRefill(formData: object): Promise<Refill> {
		return new Promise<Refill>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.updateRefillUri, formData, {
				headers: { 'Authorization': environment.api.config.headers.Authorization }
			})
				.subscribe((updatedRefill: Refill) => {
					if (updatedRefill) {
						resolve(updatedRefill);
					} else {
						reject();
					}
				});

			this.busy.setBusy(_http)
		});
	}
}
